import { render } from "./RequisicoesList.vue?vue&type=template&id=273779c8&scoped=true"
import script from "./RequisicoesList.vue?vue&type=script&lang=js"
export * from "./RequisicoesList.vue?vue&type=script&lang=js"

import "./RequisicoesList.vue?vue&type=style&index=0&id=273779c8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-273779c8"]])

export default __exports__